import Config from '@config';
import { initializeMeterLocationsApi } from '@gasbi/shared';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

const meterLocations = initializeMeterLocationsApi({
  baseUrl: Config.VITE_API_CLIENT_URL,
  baseQuery: axiosBaseQuery,
});

export const {
  meterLocationsApi,
  useGetMeterLocationsQuery,
  useGetMeterLocationByIdQuery,
} = meterLocations;
